import iso9001Pdf from "./ISO 9001 Kalite Sertifikası-20250923.pdf";
import iso9001Preview from "./ISO 9001 Kalite Sertifikası-20250923.png";
import iatfPdf from "./IATF 16949 Kalite Sertifikası-20250923.pdf";
import iatfPreview from "./IATF 16949 Kalite Sertifikası-20250923.png";
import trCertificatePdf from "./Certificate_TR014955_9S2L3JQ.pdf";
import trCertificatePreview from "./Certificate_TR014955_9S2L3JQ.png";

export const documents = [
  {
    id: "iso-9001",
    titleKey: "documents_iso9001_title",
    descriptionKey: "documents_iso9001_description",
    tagKey: "documents_iso9001_tag",
    preview: iso9001Preview,
    pdf: iso9001Pdf,
    downloadName: "ISO-9001-Certificate.pdf",
  },
  {
    id: "iatf-16949",
    titleKey: "documents_iatf_title",
    descriptionKey: "documents_iatf_description",
    tagKey: "documents_iatf_tag",
    preview: iatfPreview,
    pdf: iatfPdf,
    downloadName: "IATF-16949-Certificate.pdf",
  },
  {
    id: "tr-014955",
    titleKey: "documents_tr_title",
    descriptionKey: "documents_tr_description",
    tagKey: "documents_tr_tag",
    preview: trCertificatePreview,
    pdf: trCertificatePdf,
    downloadName: "TR014955-Conformity-Certificate.pdf",
  },
];
